import {
  KeyboardArrowDown as CaretIcon,
  Language as LanguageIcon,
} from "@mui/icons-material";
import { Button, Menu, MenuItem } from "@mui/material";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useActiveLanguage,
  useCapitalize,
  useLanguages,
  useSetLanguage,
} from "../../i18n";

export default function LanguageToggle() {
  const languages = useLanguages();
  const activeLanguage = useActiveLanguage();
  const { t } = useTranslation("i18n");
  const capitalize = useCapitalize();
  const setLanguage = useSetLanguage();
  const [anchor, setAnchor] = useState<HTMLElement | undefined>();
  const close = useCallback(() => setAnchor(undefined), []);
  const onClick = useCallback(
    (code: string) => async () => {
      await setLanguage(code);
      close();
    },
    [setLanguage, close],
  );

  return (
    <>
      <Button
        startIcon={<LanguageIcon />}
        endIcon={<CaretIcon />}
        color="inherit"
        onClick={(e) => setAnchor(e.currentTarget)}
      >
        {capitalize(t(`languages.${activeLanguage.code}`))}
      </Button>
      <Menu open={Boolean(anchor)} anchorEl={anchor} onClose={close}>
        {languages.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={onClick(lang.code)}
            selected={lang.active}
          >
            {capitalize(
              t(`languages.${lang.code}`, { lng: lang.code, defaultValue: "" }),
            )}
            {lang.code !== activeLanguage.code && (
              <> ({capitalize(t(`languages.${lang.code}`))})</>
            )}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
